(function () {
  var componentId = 'hostClinicsPanelBillingEditorComponent';
  var app = angular.module('app');

  function controller(
    $scope, 
    financeCommonLookupSvc,
    enumTenantClinicType,
    enumFinanceKnownBillingAccountType
  ) {
    const vm = this;
    vm.loading = 0;
    vm.saving = 0;
    vm.isCreate = false;
    vm.isEditing = false;
    vm.registeredTax = 0;

    vm.lookupBillingAccount = lookupBillingAccount;
    vm.setBillingDetails = setBillingDetails;
    vm.linkBillingAccountTooltip = App.localize('LinkPreexistingBillingAccountNarrative');

    vm.hasRegionalSystemSupport = abp.setting.getBoolean('Hms.Feature.RegionalSystemSupport');

    vm.enums = {
      knownBillingAccountType: enumFinanceKnownBillingAccountType
    };
    vm.enums.tenantClinicType = enumTenantClinicType;

    vm.permissions = {
      changeServiceChargeRate: abp.auth.isGranted('Host.Clinics.Edit.ChangeServiceChargeRate'),
    };

    vm.$onInit = function () {
      vm.container.addWidget(this);

      // Check if account owner is sg account owner on init.

      vm.isSgAccountOwner = vm.accountOwnerCountryCode === 'SG';

      updateTaxDisplayName();
      lookupBillingAccount();
    };

    vm.$onChanges = function (changes) {
      vm.isCreate = vm.data ? !vm.data.id : false;
      if (vm.data && vm.data.taxRegistrationNumber != null) vm.registeredTax = 1;
      if (changes.panelRequest) prefill(vm.panelRequest);

      // Check if account owner is sg account owner on changes.

      vm.isSgAccountOwner = vm.accountOwnerCountryCode === 'SG';

      updateTaxDisplayName();

      // If not sg account owner, force tax inclusive option to false as only supported
      // for sg account owners.

      if (vm.data && !vm.isSgAccountOwner) {
        vm.data.isTaxInclusive = false;
      }
    };

    vm.isDirty = function () {
      return $scope.panelCreateEditBillingForm && $scope.panelCreateEditBillingForm.$dirty;
    };

    vm.setPristine = function () {
      $scope.panelCreateEditBillingForm.$setPristine();
    };

    function prefill(request) {
      if (!request || !vm.data || !vm.isCreate) return;

      vm.data.street = request.street;
      vm.data.city = request.city;
      vm.data.state = request.state;
      vm.data.postcode = request.postcode;
      vm.data.countryCode = request.countryCode;
    }

    function lookupBillingAccount(search, billingAccountId) {
      const keyword = _.trim(search || '');

      if (keyword.length > 0 && keyword.length < 2) return;

      vm.loading += 1;
      financeCommonLookupSvc
        .getBillingAccounts({
          filter: keyword,
          maxResultCount: 20,
          id: billingAccountId,
          type: 1, // Debtor.
          isTenantless: true
        })
        .success((data) => {
          if (data) {
            vm.billingAccounts = data.items;
            if (billingAccountId) {
              vm.billingAccount = _.find(vm.billingAccounts, ['id', billingAccountId]);
            }
          }
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    // Populate billing details based on selected tenantless billing account

    function setBillingDetails (selectedBillingAccount) {
      if (selectedBillingAccount && vm.isCreate) {
        vm.data = angular.copy(selectedBillingAccount.billingAddress);

        vm.data.billingAccountId = selectedBillingAccount.id;
  
        vm.data.billingAccountType = selectedBillingAccount.type === 1 
          ? vm.enums.knownBillingAccountType.Debtor.id 
          : vm.enums.knownBillingAccountType.Creditor.id;
      }
    }

    function updateTaxDisplayName() {
      vm.taxDisplayName = 'GST';

      const countryCodesForVat = ['ID', 'TH'];

      if (countryCodesForVat.includes(vm.accountOwnerCountryCode)) vm.taxDisplayName = 'VAT';
    }

    vm.onRegisteredTax = function () {
      if (vm.isCreate) vm.data.isTaxInclusive = true;

      if (vm.registeredTax == 0) {
        vm.data.taxRegistrationNumber = null;
        vm.data.isTaxInclusive = false;
      }
    };

    // Force validation on this form.
    // True if valid, otherwise, false.

    vm.validateForm = function (error) {
      var form = $scope.panelCreateEditBillingForm;
      App.touchFormErrors(form);
      error = !(form.$valid && !vm.invalidPostcode);
    };

    // Generate the payload from this form to send to ClinicAppService API.

    vm.getPayload = function (settings) {
      _.extend(settings, {
        billing: vm.data,
      });
    };

    // Ask container to save this widget.

    vm.save = function () {
      vm.container.saveWidget(vm);
    };
  }

  app.component(componentId, {
    require: {
      container: '^hostClinicsPanelEditorContainerComponent',
    },
    bindings: {
      data: '=',
      panelType: '<',
      panelRequest: '<', // For prefilling.
      accountOwnerCountryCode: '<',
    },
    templateUrl: require('/App/host/views/clinics/panelEditor/panelBillingEditor/panelBillingEditor.component.html'),
    controller: [
      '$scope', 
      'abp.services.finance.commonLookup', 
      'Hms.MultiTenancy.TenantClinicType', 
      'Hms.Finance.KnownBillingAccountType',
      controller
    ],
    controllerAs: 'vm',
  });
})();
